import { useState } from 'react';
import { useContractsCount } from '../../../hooks/useContracts';
import { usePlans } from '../../../hooks/usePlans';
import { useGroups } from '../../../hooks/useGroups';
import { useLegalEntities } from '../../../hooks/useLegalEntities';
import { useConstructionTypes } from '../../../hooks/useConstructionTypes';
import { useSubscribers } from '../../../hooks/useSubscribers';
import { useAdditionals } from '../../../hooks/useAdditionals';
import { usePaymentMethods } from '../../../hooks/usePaymentMethods';
import { useReleaseReasons } from '../../../hooks/useReleaseReasons';
import { usePreAdjudicationReasons } from '../../../hooks/usePreAdjudicationReasons';

/**
 * Hook personalizado para gestionar el estado y lógica de la tabla de contratos
 * Sigue los patrones establecidos en el proyecto
 */
export const useContractsTable = () => {
  // Estados locales
  const [dialogOpen, setDialogOpen] = useState(false);
  const [contractFilters, setContractFilters] = useState({});
  const [isArchiveDialog, setIsArchiveDialog] = useState(false);
  const [save, setSave] = useState(false);

  // Queries principales
  const { data: contractsCount = {}, isLoading: contractsCountLoading } = useContractsCount(false);

  const { data: archivedContractsCount = {}, isLoading: archivedCountLoading } =
    useContractsCount(true);

  // Datos de soporte necesarios para las tablas y diálogos
  const { data: plans = [], isLoading: plansLoading } = usePlans();
  const { data: groups = [], isLoading: groupsLoading } = useGroups();

  // Datos adicionales que se precargan para los diálogos
  const { isLoading: legalEntitiesLoading } = useLegalEntities();
  const { isLoading: constructionTypesLoading } = useConstructionTypes();
  const { isLoading: subscribersLoading } = useSubscribers();
  const { isLoading: additionalsLoading } = useAdditionals();
  const { isLoading: paymentMethodsLoading } = usePaymentMethods();
  const { isLoading: releaseReasonsLoading } = useReleaseReasons();
  const { isLoading: preAdjReasonsLoading } = usePreAdjudicationReasons();

  // Estado de carga global
  const isLoading =
    contractsCountLoading ||
    archivedCountLoading ||
    plansLoading ||
    groupsLoading ||
    legalEntitiesLoading ||
    constructionTypesLoading ||
    subscribersLoading ||
    additionalsLoading ||
    paymentMethodsLoading ||
    releaseReasonsLoading ||
    preAdjReasonsLoading;

  /**
   * Maneja la apertura del diálogo para contratos activos
   */
  const handleOpenActiveDialog = () => {
    setIsArchiveDialog(false);
    setDialogOpen(true);
  };

  /**
   * Maneja la apertura del diálogo para contratos archivados
   */
  const handleOpenArchivedDialog = () => {
    setIsArchiveDialog(true);
    setDialogOpen(true);
  };

  /**
   * Maneja el cierre del diálogo
   */
  const handleCloseDialog = () => {
    setDialogOpen(false);
    setContractFilters({});
    setSave(!save);
  };

  /**
   * Maneja la edición de contratos - recibe filtros para obtener contratos
   * @param {Object} filters - Filtros para obtener contratos
   */
  const handleEditContracts = (filters) => {
    setContractFilters(filters || {});
  };

  return {
    // Estados de datos
    contractsCount,
    archivedContractsCount,
    isLoading,

    // Estados de diálogo
    dialogOpen,
    contractFilters,
    isArchiveDialog,

    // Datos de soporte
    plans,
    groups,

    // Funciones de manejo
    handleOpenActiveDialog,
    handleOpenArchivedDialog,
    handleCloseDialog,
    handleEditContracts,

    // Control de refrescos
    save,
    setSave,
  };
};
